import { connect } from 'react-redux'

import {
  resetUser,
  setUser,
  setEmail,
  clearEmail,
  setUserLastAccessType,
} from 'src/modules/Users/actions'
import { setSettings, resetApp, setFeatures } from 'src/modules/App/actions'

import EmailVerification from './EmailVerification'

const mapDispatchToProps = {
  setUser,
  setSettings,
  resetUser,
  resetApp,
  setEmail,
  clearEmail,
  setUserLastAccessType,
  setFeatures,
}

const mapStateToProps = state => {
  return {
    isChatEmpty: state.chat.isChatEmpty,
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(EmailVerification)
